class QuizCollectionForm extends HTMLElement {
  connectedCallback() {
    this.submitButtons = this.querySelectorAll('.quiz__atc-button');
    this.errorElements = this.querySelectorAll('.quiz__error');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.submitButtons.forEach((button) => button.addEventListener('click', this.handleSubmit));
  }

  disconnectedCallback() {
    this.submitButtons?.forEach((button) => button.removeEventListener('click', this.handleSubmit));
  }

  setError(message) {
    this.errorElements.forEach((element) => {
      element.textContent = message || '';
    });
  }

  setLoading(isLoading) {
    this.classList.toggle('loading', isLoading);
    this.submitButtons.forEach((button) => {
      button.disabled = isLoading;
    });
  }

  dispatchCartUpdate(cart) {
    const event = new Event('cart:update', { bubbles: true });
    event.detail = {
      resource: cart,
      sourceId: 'quiz-collection-form',
      data: {
        source: 'quiz-collection-form',
        itemCount: cart.item_count,
        variantId: this.dataset.bundleVariantId,
      },
    };

    this.dispatchEvent(event);
    document.querySelector('cart-drawer-component')?.open();
  }

  async handleSubmit() {
    const variantId = this.dataset.bundleVariantId;

    if (!variantId) {
      this.setError('Dieses Bundle ist aktuell nicht verfügbar.');
      return;
    }

    this.setError('');
    this.setLoading(true);

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        }),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.description || result.message || 'Das Bundle konnte nicht in den Warenkorb gelegt werden.');
      }

      const cartResponse = await fetch('/cart.js', {
        headers: {
          Accept: 'application/json',
        },
      });
      const cart = await cartResponse.json();

      this.dispatchCartUpdate(cart);
    } catch (error) {
      this.setError(error.message || 'Das Bundle konnte nicht in den Warenkorb gelegt werden.');
    } finally {
      this.setLoading(false);
    }
  }
}

if (!customElements.get('quiz-collection-form')) {
  customElements.define('quiz-collection-form', QuizCollectionForm);
}
